export function BxHome(props) {
  return (
    <svg width="2.5em" height="2.5em" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M3 13h1v7c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-7h1a1 1 0 0 0 .707-1.707l-9-9a.999.999 0 0 0-1.414 0l-9 9A1 1 0 0 0 3 13zm7 7v-5h4v5h-4zm2-15.586l6 6V15l.001 5H16v-5c0-1.103-.897-2-2-2h-4c-1.103 0-2 .897-2 2v5H6v-9.586l6-6z"
      ></path>
    </svg>
  );
}

export function SubwayCompass(props) {
  return (
    <svg width="2.5em" height="2.5em" viewBox="0 0 512 512" {...props}>
      <path
        fill="currentColor"
        d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zm0 472.6c-119.6 0-216.6-97-216.6-216.6S136.4 39.4 256 39.4s216.6 97 216.6 216.6s-97 216.6-216.6 216.6zm-137.8-78.8l187.1-88.6l88.6-187.1l-187.1 88.6l-88.6 187.1zm167.3-108.3l-118.2 59.1l59.1-118.2l59.1 59.1z"
      ></path>
    </svg>
  );
}

export function BxBxsVideos(props) {
  return (
    <svg width="2.5em" height="2.5em" viewBox="0 0 24 24" {...props}>
      <path d="M4 8H2v12a2 2 0 0 0 2 2h12v-2H4z" fill="currentColor"></path>
      <path
        d="M20 2H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm-9 12V6l7 4z"
        fill="currentColor"
      ></path>
    </svg>
  );
}

export function FluentThumbLike16Regular(props) {
  return (
    <svg width="2.5em" height="2.5em" viewBox="0 0 16 16" {...props}>
      <path
        fill="currentColor"
        d="M8.035 1.923c.21-.52.795-1.08 1.546-.871c.59.164.973.52 1.193.996c.204.443.254.965.264 1.462c.01.535-.102 1.176-.233 1.738a14.53 14.53 0 0 1-.195.74h1.385a2 2 0 0 1 1.919 2.563l-1.364 4.646a2.5 2.5 0 0 1-3.148 1.681l-5.356-1.682a2 2 0 0 1-1.273-1.205l-.52-1.384a2 2 0 0 1 .856-2.426l1.872-1.104a4.063 4.063 0 0 0 .523-.495c.344-.389.817-1.036 1.292-2.045c.205-.436.377-.779.533-1.09c.253-.503.465-.924.706-1.524ZM5.519 7.92a.517.517 0 0 1-.017.01L3.617 9.042a1 1 0 0 0-.428 1.213l.52 1.384a1 1 0 0 0 .637.603L9.7 13.924a1.5 1.5 0 0 0 1.89-1.008l1.363-4.646a1 1 0 0 0-.96-1.282H9.927a.5.5 0 0 1-.471-.667c.1-.282.252-.771.376-1.302c.126-.538.215-1.082.207-1.49c-.01-.468-.059-.816-.173-1.062c-.098-.215-.251-.368-.552-.452c-.043-.012-.094-.008-.16.035a.538.538 0 0 0-.19.246a20.426 20.426 0 0 1-.765 1.651c-.155.309-.318.634-.497 1.015c-.514 1.094-1.04 1.822-1.45 2.283c-.204.23-.378.393-.506.502a2.922 2.922 0 0 1-.202.157l-.016.01l-.005.004l-.003.002Zm-.543-.84l-.001.001Z"
      ></path>
    </svg>
  );
}

export function MdiClockTimeFourOutline(props) {
  return (
    <svg width="2.5em" height="2.5em" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M12 20c4.4 0 8-3.6 8-8s-3.6-8-8-8s-8 3.6-8 8s3.6 8 8 8m0-18c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12S6.5 2 12 2m5 11.9l-.7 1.3l-5.3-2.9V7h1.5v4.4l4.5 2.5Z"
      ></path>
    </svg>
  );
}

export function PhClockCounterClockwiseFill(props) {
  return (
    <svg width="2.5em" height="2.5em" viewBox="0 0 256 256" {...props}>
      <path
        fill="currentColor"
        d="M136 80v43.4l37.6 21.7a8 8 0 0 1-4 14.9a7.1 7.1 0 0 1-4-1.1l-41.6-24h-.2l-.4-.2l-.3-.3l-.3-.2l-.3-.3l-.2-.2c-.2-.1-.3-.3-.4-.4l-.2-.2l-.2-.4l-.2-.3l-.2-.3a.5.5 0 0 1-.2-.4l-.2-.3c0-.1-.1-.2-.1-.4a.4.4 0 0 1-.1-.3l-.2-.4a.4.4 0 0 0-.1-.3c0-.2 0-.3-.1-.4v-.4c0-.2-.1-.3-.1-.4V80a8 8 0 0 1 16 0Zm59.9-19.9a96.2 96.2 0 0 0-135.8 0l-8.3 8.3l-14.3-14.3a8 8 0 0 0-8.7-1.8a8.2 8.2 0 0 0-5 7.4v40a8 8 0 0 0 8 8h40a8 8 0 0 0 5.7-13.6L63.1 79.7l8.3-8.3a80 80 0 1 1 0 113.2a7.9 7.9 0 0 0-11.3 0a8 8 0 0 0 0 11.3A96 96 0 0 0 195.9 60.1Z"
      ></path>
    </svg>
  );
}

export function MdiDotsVertical(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M12 16a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m0-6a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m0-6a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2Z"
      ></path>
    </svg>
  );
}

export function IcBaselinePlaylistAdd(props) {
  return (
    <svg width="2.5rem" height="2.5rem" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M14 10H3v2h11v-2zm0-4H3v2h11V6zm4 8v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zM3 16h7v-2H3v2z"
      ></path>
    </svg>
  );
}

export function WatchLaterIcon(props) {
  return (
    <svg width="2.5rem" height="2.5rem" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M12 20c4.4 0 8-3.6 8-8s-3.6-8-8-8s-8 3.6-8 8s3.6 8 8 8m0-18c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12S6.5 2 12 2m5 11.9l-.7 1.3l-5.3-2.9V7h1.5v4.4l4.5 2.5Z"
      ></path>
    </svg>
  );
}

export function LikeBtn(props) {
  return (
    <svg width="2.5rem" height="2.5rem" viewBox="0 0 16 16" {...props}>
      <path
        fill="currentColor"
        d="M8.035 1.923c.21-.52.795-1.08 1.546-.871c.59.164.973.52 1.193.996c.204.443.254.965.264 1.462c.01.535-.102 1.176-.233 1.738a14.53 14.53 0 0 1-.195.74h1.385a2 2 0 0 1 1.919 2.563l-1.364 4.646a2.5 2.5 0 0 1-3.148 1.681l-5.356-1.682a2 2 0 0 1-1.273-1.205l-.52-1.384a2 2 0 0 1 .856-2.426l1.872-1.104a4.063 4.063 0 0 0 .523-.495c.344-.389.817-1.036 1.292-2.045c.205-.436.377-.779.533-1.09c.253-.503.465-.924.706-1.524ZM5.519 7.92a.517.517 0 0 1-.017.01L3.617 9.042a1 1 0 0 0-.428 1.213l.52 1.384a1 1 0 0 0 .637.603L9.7 13.924a1.5 1.5 0 0 0 1.89-1.008l1.363-4.646a1 1 0 0 0-.96-1.282H9.927a.5.5 0 0 1-.471-.667c.1-.282.252-.771.376-1.302c.126-.538.215-1.082.207-1.49c-.01-.468-.059-.816-.173-1.062c-.098-.215-.251-.368-.552-.452c-.043-.012-.094-.008-.16.035a.538.538 0 0 0-.19.246a20.426 20.426 0 0 1-.765 1.651c-.155.309-.318.634-.497 1.015c-.514 1.094-1.04 1.822-1.45 2.283c-.204.23-.378.393-.506.502a2.922 2.922 0 0 1-.202.157l-.016.01l-.005.004l-.003.002Zm-.543-.84l-.001.001Z"
      ></path>
    </svg>
  );
}

export function LikeBtnFilled(props) {
  return (
    <svg width="2.5rem" height="2.5rem" viewBox="0 0 16 16" {...props}>
      <path
        fill="#29bae2"
        d="M9.58 1.052c-.75-.209-1.336.35-1.545.871c-.24.6-.453 1.021-.706 1.524a44.75 44.75 0 0 0-.533 1.09c-.475 1.01-.948 1.656-1.293 2.045a4.063 4.063 0 0 1-.405.402a1.92 1.92 0 0 1-.101.081l-.016.012L3.109 8.18a2 2 0 0 0-.856 2.426l.52 1.384a2 2 0 0 0 1.273 1.205l5.356 1.682a2.5 2.5 0 0 0 3.148-1.68l1.364-4.647a2 2 0 0 0-1.92-2.563H10.61c.066-.227.133-.479.195-.74c.131-.562.243-1.203.232-1.738c-.009-.497-.06-1.019-.264-1.462c-.219-.475-.602-.832-1.192-.996ZM4.978 7.08l-.002.001Z"
      ></path>
    </svg>
  );
}

export function MdiTrashCan(props) {
  return (
    <svg width="2.5rem" height="2.5rem" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M9 3v1H4v2h1v13a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6h1V4h-5V3H9m0 5h2v9H9V8m4 0h2v9h-2V8Z"
      ></path>
    </svg>
  );
}

export function IcBaselineClose(props) {
  return (
    <svg width="2.5rem" height="2.5rem" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12z"
      ></path>
    </svg>
  );
}

export function MdiShare(props) {
  return (
    <svg width="2.5rem" height="2.5rem" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="m21 12l-7-7v4C7 10 4 15 3 20c2.5-3.5 6-5.1 11-5.1V19l7-7Z"
      ></path>
    </svg>
  );
}
